export const environment = {
  production: true,
  adTenantId: "",
  adClientId: "",
  adRedirectUri: "",
  msLogin: true
};
